import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DotSpinnerComponent } from './dot-spinner.component';

@NgModule({
	imports: [
		CommonModule,
	],
	exports: [
		DotSpinnerComponent,
	],
	providers: [
	],
	declarations: [
		DotSpinnerComponent,
	],
})
export class DotSpinnerModule { }
